/**
 * 게시판 글 관리 (/adm/board/{code}) — 좌: 글 목록(DataTables) / 우: 편집 패널($j.F.Admin.BoardPostForm)
 * ($j.Pages.Admin.BoardPosts / body data-page-name="BoardPosts")
 *
 * 우측 폼은 partial 을 ajax 로 받아 넣고 init 한다. 저장·삭제 콜백으로 목록을 다시 읽는다.
 * 게시판 코드·공개 게시판 여부·미리보기 회원번호는 #page-data.
 */
export default class BoardPosts {
    initialize() { initialize(); }
}

let BOARD_CODE = '';
let PUBLIC_ONLY = false;   // 전체 공개 게시판(명절/이벤트) — 대상 칸 대신 공개기간
let PREVIEW_MB_NO = 0;     // 대리로그인 대상(관리자 연결회원). 0이면 단독 미리보기로 폴백
let $table = null;
let currentPostId = null;// 우측에 로드된 글 (신규는 null)

function initialize(){
    const d = JSON.parse(document.getElementById('page-data').textContent);
    BOARD_CODE    = d.boardCode;
    PUBLIC_ONLY   = d.publicOnly;
    PREVIEW_MB_NO = d.previewMbNo;

    initTable();
    initHandler();
}

function initHandler(){
    $('#btnWrite').on('click', () => loadForm(null));
    $('#btnSearch').on('click', () => $table && $table.ajax.reload(null, false));
    $('#search-title').on('keypress', e => {
        if (e.which === 13) { e.preventDefault(); $table && $table.ajax.reload(null, false); }
    });
    $('#filter-category, #filter-hidden').on('change', () => $table && $table.ajax.reload(null, false));

    // 게시판 선택 → 해당 게시판 글관리로 이동
    $('#filter-board').on('change', function(){
        const code = $(this).val();
        if (code && code !== BOARD_CODE) location.href = '/adm/board/' + code;
    });

    // 게시판관리 → /adm/board 내용을 모달로
    $('#btnBoardMgmt').on('click', function(){
        $j.Ui.JBModal.open('boardMgmt', '/adm/board?bare=1', null, {title:'게시판 관리', width:'900px', onOpen: () => $j.F.Admin.BoardMaster.init()});
    });

    // 행 클릭 (제목·No 둘 다) → 폼 로드
    $('#post-table tbody').on('click', 'tr', function(){
        const num = $(this).data('num');
        if (!num) return;
        loadForm(num);
    });

    // 푸시 발송 — 우측 헤더의 버튼 (현재 로드된 글 대상)
    $('#btnPush').on('click', function(){
        if (!currentPostId) return;
        openPushModal(currentPostId);
    });

    // 미리보기 — 대리로그인으로 실제 앱 화면(/m/alim)을 띄운 뒤 그 화면에서 이 팝업을 강제로 띄운다.
    //   복귀 URL 의 ?popupPreview={공지id} 를 Bootstrap 이 읽어 preview() 로 렌더한다.
    //   연결회원이 없으면 단독 미리보기(/m/notice/{id}/preview, 배경 없음)로 폴백.
    $('#btnPreview').on('click', function(){
        if (!currentPostId) return;
        let url;
        if (PREVIEW_MB_NO) {
            const ret = encodeURIComponent('/m/alim?popupPreview=' + currentPostId);
            url = '/m/login/proxy?work_num=' + PREVIEW_MB_NO + '&returnurl=' + ret;
        } else {
            url = '/m/notice/' + currentPostId + '/preview';
        }
        // 모바일 비율 팝업창으로 미리보기
        const w = 430, h = 860;
        const left = window.screenX + Math.max(0, (window.outerWidth  - w) / 2);
        const top  = window.screenY + Math.max(0, (window.outerHeight - h) / 2);
        window.open(url, 'noticePreview',
            'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top +
            ',toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes');
    });

    // 우측 패널 닫기
    $('#btnClosePanel').on('click', closeRightPanel);

    // 푸시 모달(JBModal) 버튼
    $(document).on('click', '#boardPushModal [data-bp-push]', function(){
        if (this.dataset.bpPush === 'cancel') $j.Ui.JBModal.close('boardPushModal');
        else sendBoardPush(Number(this.dataset.n));
    });
}

// ── 좌·우 레이아웃 토글 ──
function openRightPanel(){
    $('#board-left').removeClass('col-12').addClass('col-5');
    $('#board-right').show();
    applyColumnVisibility(true);
}
function closeRightPanel(){
    try { $j.F.Admin.BoardPostForm.destroy(); } catch(e) {}
    $('#post-form-container').empty();
    $('#board-right').hide();
    $('#board-left').removeClass('col-5').addClass('col-12');
    currentPostId = null;
    highlightRow(null);
    applyColumnVisibility(false);
}
function applyColumnVisibility(narrow){
    if (!$table) return;
    const total = $table.columns().count();
    for (let i = 0; i < total; i++) {
        const visible = narrow
            ? NARROW_VISIBLE_COLS.includes(i)
            : !WIDE_HIDDEN_COLS.includes(i);
        $table.column(i).visible(visible, false);
    }
    $table.columns.adjust();
}

// 컬럼 — 대상 칸(본사·지사·유형·장비)은 전체 공개 게시판에선 공개기간 한 칸으로 바뀐다.
// - 풍부 모드 (우측 닫힘) : 'date' 숨김, 나머지 표시
// - 좁은 모드 (우측 열림) : No·제목·'date' 만 — 시분초 컬럼 대신 날짜만
// 인덱스는 게시판마다 달라지므로 name 으로 찾는다.
let NARROW_VISIBLE_COLS = [];
let WIDE_HIDDEN_COLS    = [];

function initTable(){
    const targetCols = PUBLIC_ONLY ? [
        { data: 'popup_start', title:'시작일', width:'190px', className:'text-center',
            render: (d, type, row) => renderPeriodStart(row)
        },
        { data: 'popup_end',   title:'종료일', width:'140px', className:'text-center',
            render: (d, type, row) => row.is_popup == 1 ? (formatMinute(d) || '제한없음') : ''
        },
    ] : [
        { data: 'bonsa_str',      title:'본사',   width:'100px' },
        { data: 'gisa_str',       title:'지사',   width:'140px',
            render: renderGisaBadges
        },
        { data: 'tar_member_str', title:'유형',   width:'140px',
            render: renderMemberBadges
        },
        { data: 'tar_car_str',    title:'장비',   width:'160px',
            render: renderCarBadges
        },
    ];
    const columns = [
        { data: 'rownum', title: 'No', width:'50px', className:'text-center', name:'no' },
        { data: 'title',  title: '제목', width:'360px', name:'title',
            render: function(data, type, row){
                let html = '';
                if (row.pinned_int === 1) html += '<span class="badge badge-danger mr-1">고정</span>';
                // 팝업 뱃지에 뜨는 차례를 함께 적는다 — 순서는 글 편집 폼에서 고친다 (0=미지정)
                if (row.is_popup == 1) {
                    const odr = parseInt(row.popup_odr, 10) || 0;
                    html += `<span class="badge badge-warning mr-1">팝업${odr ? ' ' + odr : ''}</span>`;
                }
                if (row.is_hidden_int === 1) html += '<span class="badge badge-secondary mr-1">비공개</span>';
                html += escapeHtml(data || '(제목없음)');
                return html;
            }
        },
        { data: 'category', title:'분류', width:'90px',
            render: d => d ? `<span class="badge badge-secondary">${escapeHtml(d)}</span>` : ''
        },
        ...targetCols,
        { data: 'created_at',     title:'등록일', width:'160px', className:'text-center',
            render: d => d ? $j.Common.Util.formatDateTime(d) : ''
        },
        { data: 'created_at',     title:'등록일', width:'100px', className:'text-center', visible:false, name:'date',
            render: d => d ? formatDate(d) : ''
        },
    ];
    const idx = name => columns.findIndex(c => c.name === name);
    NARROW_VISIBLE_COLS = [idx('no'), idx('title'), idx('date')];
    WIDE_HIDDEN_COLS    = [idx('date')];

    $table = new DataTable('#post-table', {
        autoWidth: false,
        columns: columns,
        headerCallback: thead => $(thead).find('th').css('text-align','center'),
        createdRow: function(row, data){
            $(row).attr('data-num', data.num);
            if (currentPostId && parseInt(data.num,10) === parseInt(currentPostId,10)) {
                $(row).addClass('selected');
            }
        },
        ajax: {
            url:  `/adm/ajax/board/${BOARD_CODE}/posts/list`,
            type: 'post',
            data: function(d){
                d.q        = $('#search-title').val();
                d.category = $('#filter-category').val();
                d.hidden   = $('#filter-hidden').val();
            },
        },
        language: {
            emptyTable: '등록된 글이 없습니다.',
            info: '', infoEmpty: '', infoFiltered: '',
            loadingRecords: '로딩 중...',
            zeroRecords: '일치하는 결과가 없습니다.',
            paginate: { previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>" },
        },
        processing: true,
        serverSide: true,
        ordering: false,
        pageLength: 20,
        lengthChange: false,
        searching: false,
    });
}

// ── 우측 폼 로드 ──
function loadForm(num){
    // 우측 패널 펼치기 (처음 호출일 때)
    openRightPanel();

    // 이전 폼 정리 (CKEditor destroy 등)
    try { $j.F.Admin.BoardPostForm.destroy(); } catch(e) { console.error(e); }

    const url = num
        ? `/adm/ajax/board/${BOARD_CODE}/post/${num}/edit-form`
        : `/adm/ajax/board/${BOARD_CODE}/post/edit-form`;

    $('#post-form-container').html('<div class="form-panel-empty">불러오는 중...</div>');

    $.get(url, function(html){
        $('#post-form-container').html(html);
        currentPostId = num || null;
        updatePanelHeader(num);
        highlightRow(num);
        // DOM 삽입 직후 한 틱 양보 후 init (CKEditor target element 가 paint 된 뒤)
        setTimeout(() => $j.F.Admin.BoardPostForm.init({ onSaved: onBoardPostSaved, onDeleted: onBoardPostDeleted }), 0);
    }).fail(function(xhr){
        $('#post-form-container').html(
            `<div class="form-panel-empty text-danger">불러오기 실패 (${xhr.status})</div>`
        );
        currentPostId = null;
        updatePanelHeader(null);
    });
}

function updatePanelHeader(num){
    if (num) {
        $('#panel-title').text(`글 수정 (#${num})`);
        $('#btnPush').show();
        $('#btnPreview').show();
    } else {
        $('#panel-title').text('신규 글 작성');
        $('#btnPush').hide();
        $('#btnPreview').hide();
    }
}

function highlightRow(num){
    $('#post-table tbody tr').removeClass('selected');
    if (num) $(`#post-table tbody tr[data-num="${num}"]`).addClass('selected');
}

// ── 폼 모듈 콜백 ──
function onBoardPostSaved(savedNum){
    $table.ajax.reload(null, false);
    if (savedNum) {
        // 같은 글이면 우측 폼 새로고침해서 cover_keep 등 동기화
        loadForm(savedNum);
    } else {
        // 신규 저장 직후 — 새 신규 폼으로 리셋
        loadForm(null);
        $('#panel-title').text(`저장 완료 — 새 글 작성 중`);
    }
}
function onBoardPostDeleted(deletedNum){
    $table.ajax.reload(null, false);
    // 우측 패널 닫고 좌측 전체 너비로
    closeRightPanel();
}

// ── 푸시 모달 (우측 헤더 버튼 또는 행에서) ──
function openPushModal(num){
    $.get(`/adm/ajax/board/post/${num}/push-summary`, function(res){
        if (!res || !res.result) {
            alert((res && res.message) || '요약 정보를 가져오지 못했습니다.');
            return;
        }
        $j.Ui.JBModal.html('boardPushModal', pushModalHtml(res), '공지사항 푸시 보내기', {width:'520px'});
    });
}
function pushModalHtml(d){
    const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const row = (label, val) =>
        `<tr><th>${esc(label)}</th>` +
        `<td>${val || '<span class="text-muted">(전체)</span>'}</td></tr>`;
    return `
    <table class="bp-push-table">
        ${row('제목',     esc(d.title))}
        ${row('업종',     esc((d.car_type||[]).join(', ')))}
        ${row('본사',     esc(d.bonsa_str))}
        ${row('지사',     esc(d.gisa_str))}
        ${row('회원유형', esc((d.member_type||[]).join(', ')))}
        ${Number(d.is_ad) ? row('광고성', '<b>예</b> — 광고 수신(앱 푸시) 동의자에게만 · 제목 앞 (광고)') : ''}
        <tr>
            <th class="bp-push-cnt-th">대상 수</th>
            <td class="bp-push-cnt">
                ${Number(d.is_ad)
                    ? `${Number(d.count_ad).toLocaleString()} 명 <small class="text-muted">(조건 ${Number(d.count).toLocaleString()}명 중 앱 푸시 동의자)</small>`
                    : `${Number(d.count).toLocaleString()} 명`}
            </td>
        </tr>
    </table>
    <div class="bp-push-acts">
        <button type="button" class="btn btn-outline-secondary btn-sm" data-bp-push="cancel">취소</button>
        <button type="button" class="btn btn-dark btn-sm" data-bp-push="send" data-n="${d.post_id}">푸시 발송</button>
    </div>`;
}
function sendBoardPush(postId){
    if (!confirm('정말 발송할까요?\n(큐 적재 후 워커가 처리합니다.)')) return;
    $.post('/adm/ajax/board/post/broadcast', { num: postId }, function(res){
        alert((res && res.message) || '요청 처리됨');
        $j.Ui.JBModal.close('boardPushModal');
    });
}

function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}

// formatDateTime 은 $j.Common.Util.formatDateTime (시분초를 파란색으로 강조).
function formatDate(d){ return String(d || '').slice(0, 10); }
function formatMinute(d){ return String(d || '').slice(0, 16); }
function nowMinute(){
    const t = new Date(), p = n => String(n).padStart(2,'0');
    return `${t.getFullYear()}-${p(t.getMonth()+1)}-${p(t.getDate())} ${p(t.getHours())}:${p(t.getMinutes())}`;
}

// 공개기간 = 팝업 노출 기간. 앱이 분 단위로 판정하므로(PopupService) 여기서도 분까지 비교한다.
// 'YYYY-MM-DD HH:mm' 문자열은 자리수가 고정이라 사전순 비교가 곧 시각 비교다.
// 진행 상태 뱃지는 시작일 칸 앞에 붙인다.
function renderPeriodStart(row){
    if (row.is_popup != 1) return '<span class="text-muted">팝업 꺼짐</span>';
    const s = formatMinute(row.popup_start), e = formatMinute(row.popup_end);
    const badge = (s && nowMinute() < s) ? '<span class="badge badge-info mr-1">예정</span>'
                : (e && nowMinute() > e) ? '<span class="badge badge-secondary mr-1">종료</span>'
                : '<span class="badge badge-success mr-1">진행중</span>';
    return badge + (s || '제한없음');
}

// 지사 라벨 단축: "A그룹, B그룹" → 작은 원형 뱃지 [A] [B]
function renderGisaBadges(data){
    if (!data) return '';
    const items = String(data).split(/\s*,\s*/).filter(Boolean);
    return items.map(label => {
        const short = label.replace(/그룹$/, '').trim();
        return `<span class="gisa-chip" title="${escapeHtml(label)}">${escapeHtml(short)}</span>`;
    }).join(' ');
}

// 회원유형·장비 칩 색은 sass(_board-posts.scss)가 data-kind 로 칠한다 — 모르는 라벨은 기본색
function renderMemberBadges(data){
    if (!data) return '';
    if (data === '전체') return '<span class="text-muted bp-all">전체</span>';
    return String(data).split(/\s*,\s*/).filter(Boolean).map(label => {
        return `<span class="member-chip" data-kind="${escapeHtml(label)}">${escapeHtml(label)}</span>`;
    }).join(' ');
}

function renderCarBadges(data){
    if (!data) return '';
    if (data === '전체') return '<span class="text-muted bp-all">전체</span>';
    return String(data).split(/\s*,\s*/).filter(Boolean).map(label => {
        return `<span class="car-chip" data-kind="${escapeHtml(label)}">${escapeHtml(label)}</span>`;
    }).join(' ');
}
